import './index.css';
import './App.css';
import React from "react";
import IdeApp from './IdeApp';
import AppJson from './App.json';
import userConfig from './userConfig.json';

const langContent = [
  {
    javascript: '/*Welcome to exIDE, a multi-platform \nweb IDE with multi.language \nsupport for everyone!*/\n\nimport express from \'express\';\nconst app = express();\nconst port = process.env.PORT || \'8080\';\n\napp.get(\'/\', (req, res) => {\n   res.send("Hello world!");\n})\n\napp.listen(port, () => {\n   console.log("listening on port " + port);\n});',
    csharp: '',
    cpp: '',
    python: '',
    java: '',
    typescript: '',
    lua: '',
    css: '',
    html: '',
    xaml: '',
    md: '',
  }
]

const langs = [{
  name:"None",
  rawname:"none",
  extension:"txt"
},{
  name:"JavaScript",
  rawname:"javascript",
  extension:"js",
  value: langContent[0].javascript
},{
  name:"C#",
  rawname:"csharp",
  extension:"cs",
  value: langContent[0].csharp
},{
  name:"C++",
  rawname:"cpp",
  extension:"cpp",
  value: langContent[0].cpp
},{
  name:"Python",
  rawname:"python",
  extension:"py",
  value: langContent[0].python
},{
  name:"Java",
  rawname:"java",
  extension:"jar",
  value: langContent[0].java
},{
  name:"TypeScript",
  rawname:"typescript",
  extension:"ts",
  value: langContent[0].typescript
},{
  name:"Lua",
  rawname:"lua",
  extension:"lua",
  value: langContent[0].lua
},{
  name:"CSS",
  rawname:"css",
  extension:"css",
  value: langContent[0].css
},{
  name:"HTML",
  rawname:"html",
  extension:"html",
  value: langContent[0].html
},{
  name:"XAML",
  rawname:"xaml",
  extension:"xaml",
  value: langContent[0].xaml
},{
  name:"MarkDown",
  rawname:"markdown",
  extension:"md",
  value: langContent[0].md
}
]

function App() {

  setTimeout(() => langsLoad(), 2000);
  setTimeout(() => checker(), 500);

  return (

    <div id="entirePage">
      
      <div draggable="false" style={{display: 'block'}}>
    
        <div id="mainMenu" draggable="false" style={{height: '80vh', textAlign: 'center', alignContent: 'center'}}>

            <div style={{position: 'absolute', top: '0%'}}>

              <div onMouseLeave={unHoverMenu} onMouseEnter={hoverMenu} id="contextMenu" className='contextMenu' style={{width:'50px'}}>

                <img alt='context menu' className='imagE'></img>

                <div style={{display: 'none'}} id="imEg">

                  <div onLoad={unConfigMenu} onClick={configMenu} onMouseLeave={unConfigMenu} id="configMenu" style={{top: '-50px', display: 'inline-flex'}} className='menuC'>
  
                    <img id="configBtn" style={{marginBottom: '10px'}} className='im1' src={require('./config.png')} alt='context2'></img>

                    <div id="configs" >

                      <div style={{position: 'absolute', top: '50px'}}>

                        <p onClick={importer} style={{color: 'white', fontSize: '10px', marginTop: '17.5px', marginLeft: '10px', whiteSpace: 'nowrap'}}
                        >Import settings</p>

                      </div>
                      
                      <div style={{position: 'absolute', top: '80px'}}>

                        <p onClick={saver} style={{color: 'white', fontSize: '10px', marginTop: '17.5px', marginLeft: '10px', whiteSpace: 'nowrap'}}
                        >Save settings</p>

                      </div>

                      <div style={{display: 'table-column', marginTop: '55px'}}>

                        <div style={{display: 'inline-flex', position: 'absolute', whiteSpace: 'nowrap'}}>

                          <p style={{color: 'white', fontSize: '10px', marginTop: '17.5px', marginLeft: '10px'}}
                          >Show warnings</p>

                          <div id="config1">

                            <input style={{whiteSpace: 'nowrap', marginTop: '20px', marginLeft: '9px'}} type="checkbox" id='warningsCheckbox' defaultChecked={userConfig.showWarnings} onChange={checker}></input>

                          </div> 
                        
                        </div>

                        <div style={{display: 'inline-flex', position: 'absolute', marginTop: '30px', whiteSpace: 'nowrap'}}>

                          <p style={{color: 'white', fontSize: '10px', marginTop: '17.5px', marginLeft: '10px', whiteSpace: 'nowrap'}}
                          >Dark mode</p>

                          <div id="config1">

                            <input style={{whiteSpace: 'nowrap', marginTop: '20px', marginLeft: '9px'}} type="checkbox" id='nightModeCheckbox' defaultChecked={userConfig.nightMode} onChange={checker}></input>

                          </div> 

                        </div>

                      </div>

                    </div>
                  
                  </div>

                  <div id="other">
                    
                    <a href="https://www.paypal.com/donate/?hosted_button_id=Y46XW7XKFBX94" target="_blank" rel="noreferrer">
                      <img className='im' src={require('./dono.png')} alt='context2'/>
                    </a>

                  </div>

                </div>

              </div>

            </div>

            <div draggable="false" style={{marginTop: '90px'}}>

              <img draggable="false" alt="exIDE logo" id="logoBanner" style={{maxWidth: '280px'}} />

            </div>
            
            <div style={{display: 'inline-flex'}}>

              <h1 style={{color: 'white', fontSize: 50}}>ex</h1><h1 id="a2" style={{fontSize: 50}}>IDE</h1>

            </div>      

            <div style={{marginTop: '-40px', display: 'block'}}>

            </div> 

            <div style={{marginTop: '-40px', display: 'block'}}>

              <div style={{display: 'inline-flex'}}>

                <p id='p1' style={{marginTop: '20px', marginBottom: '50px', inlineSize: '65%', marginInline:'30%', fontSize: '17px'}}>exIDE is a Multi-Platform Web IDE made by <a id='a1' href="https://github.com/xhyabunny">@xhyabunny</a> powered by Monaco!</p>

              </div>

            </div> 

            <div style={{marginTop: '-40px', display: 'block'}}>

              <div style={{display: 'inline-flex'}}>

                <p id="imegText" style={{color: 'white', fontSize: '18px'}}>Loading...</p>

              </div>

            </div> 

            <div>

              <img alt="exIDE loading" id="imeg" className="App-logo" style={{height: '50px', width: '50px'}} src={require('./load.png')}></img>
              <select onChange={setLangs} style={{display: 'none', padding: '14px', backgroundColor: 'transparent', color: 'white', fontSize: '30px', borderRadius: '15px', borderWidth: '1px', borderColor: 'white'}} draggable="false" className="fonT" name="Languages" id="selectorLang"></select>

            </div>

            <div>

              <button onClick={btnClick} id="btnCreate" onMouseEnter={btnColor} onMouseLeave={btnColor2} style={{marginTop: '20px', display: 'none', padding: '18px', backgroundColor: 'gray', color: 'black', fontFamily: 'Courier New, monospace',fontSize: '30px', borderRadius: '15px', borderWidth: '0px', borderColor: 'white'}}>Create Project!</button>

            </div>

        </div>

      </div>

      <div id="ide" style={{display: "none"}}>

        <React.StrictMode>
          <IdeApp />
        </React.StrictMode>

      </div>

    </div>

  );
  

  function btnColor(){
    const btn = document.getElementById("btnCreate");
    if(userConfig.nightMode){
      btn.style.backgroundColor = "rgb(230, 230, 230)";
    }else{
      btn.style.backgroundColor = 'white'
    }
  }

  function btnColor2(){
    const btn = document.getElementById("btnCreate");
    if(userConfig.nightMode){
      btn.style.backgroundColor = "white";
    }else{
      btn.style.backgroundColor = 'rgb(230, 230, 230)'
    }
  }

  function btnClick(){
    const ide = document.getElementById('ide')
    const mainMenu = document.getElementById("mainMenu");
  //const page = document.getElementById("entirePage");

    mainMenu.style.display = "none";
    ide.style.display = "block";
  }

  function langsLoad() {
    const rr = document.getElementById("selectorLang");
    const rr1 = document.getElementById("imeg");
    const rr2 = document.getElementById("imegText");
    const rr3 = document.getElementById("btnCreate");
    rr.replaceChildren();
    for(var i in langs){
      var option = document.createElement('option');
      option.textContent = langs[i].name;
      option.classList.add("opt");
      option.value = langs[i].rawname;
      rr.appendChild(option);
    }
    rr.style.display = 'inline';
    rr1.style.display = 'none';
    rr2.textContent = 'Choose a language for your project!';
    rr3.style.display = 'inline';
    btnColor()
  }

  function setLangs(){
    var val = document.getElementById("selectorLang").value;
    console.log(val);
    AppJson.lang = val;
    switch(AppJson.lang){

      case "none": 
        AppJson.extension = "txt";
      break;
  
      case "javascript": 
        AppJson.extension = "js";
      break;
  
      case "csharp": 
        AppJson.extension = "cs";
      break;
  
      case "cpp": 
        AppJson.extension = "cpp";
      break;
  
      case "python": 
        AppJson.extension = "py";
      break;
  
      case "java": 
        AppJson.extension = "jar";
      break;
  
      case "typescript": 
        AppJson.extension = "ts";
      break;
  
      case "lua": 
        AppJson.extension = "lua";
      break;
  
      case "css": 
        AppJson.extension = "css";
      break;
  
      case "html": 
        AppJson.extension = "html";
      break;
  
      case "xaml": 
        AppJson.extension = "xaml";
      break;
  
      case "markdown": 
        AppJson.extension = "md";
      break;
  
      default:
        AppJson.extension = "none";
      break;
  
    }
  }

  function hoverMenu(){
    var img = document.getElementById("imEg");
    img.style.display = "block";
  }

  function unHoverMenu(){
    var img = document.getElementById("imEg");
    img.style.display = "none";
  }

  function configMenu(){
    var conf = document.getElementById("configMenu");
    var conf1 = document.getElementById("config1");
    var conf2 = document.getElementById("configBtn");
    var conf3 = document.getElementById("configs");
    var conf4 = document.getElementById("other");
    conf.classList.add('menuC1');
    conf.style.backgroundColor = "black";
    conf1.style.display = "block";
    conf2.style.marginLeft = "10px";
    conf3.style.display = "inline-flex";
    conf4.style.display = "none";
  }

  function unConfigMenu(){
    var conf = document.getElementById("configMenu");
    var conf1 = document.getElementById("config1");
    var conf2 = document.getElementById("configBtn");
    var conf3 = document.getElementById("configs");
    var conf4 = document.getElementById("other");
    conf.classList.remove('menuC1');
    conf.style.backgroundColor = "transparent";
    conf1.style.display = "none";
    conf2.style.marginLeft = "0px";
    conf3.style.display = "none";
    conf4.style.display = "block";
  }

  function checker(){
    const warningsCheckbox = document.getElementById('warningsCheckbox');
    const nightModeCheckbox = document.getElementById('nightModeCheckbox');
    const p_ = document.getElementById('p1');
    const a1 = document.getElementById('a1');
    const a2 = document.getElementById('a2');
    const logoBanner = document.getElementById('logoBanner');
    let realCSSVars = document.querySelector(":root");
    if(warningsCheckbox.checked){
      userConfig.showWarnings = true;
    }else{
      userConfig.showWarnings = false;
    }
    if(nightModeCheckbox.checked){
      userConfig.nightMode = "vs-dark";
      console.log(userConfig.nightMode)
      realCSSVars.style.setProperty("--backGclr", "#1F1F1E");
      realCSSVars.style.setProperty("--backGclrContextMenu", "#111");
      realCSSVars.style.setProperty("--optClr", "white");
      realCSSVars.style.setProperty("--contextMenu", "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAAXNSR0IArs4c6QAAA9NJREFUaEPtl29IE2EcxzeZpaIrpV6YhtKtzBJfTDAjo3vRG29vxJSLCo/JsTc1/7zYgmkEzUBFkc5/TB1iWkoiydAR+EYLhLQsqSU5NYNBwiQzczoqLk69dpu7e56tYyRsr8Y9vz+f53vf+91zUsk+/En3IbMkDB2quxZWOqy0gAJhe7DiqNVqo1KpxGZmZp51dnZWim0b0ZVua2t7l5qSkkHvkjocjlmNRnNGTHBRobOysmKMRuMGU5SFZmCbm5tzrFbrS7HARYXu7e11JCQkJHHhmAbf19dXcBw/+l9CW61WrsBejBiGiSaQaIU6Ojpmk5KTTnv5goPtdDo/EQRxQgy1RYPmU9njb6kEw/JE6SdKkf7+fqdcLj8CUnHT5Vq7Ulh4GBQHWg8YGkXRDARBrubknC+IiYk+FB8ff0yoie8kYWJXV79+2XBtrk1NTj61222Px8Ym3oNAfR9uYLxer3+IougNiQTmKOsPk9OCf5keHx/vq62tvQ4CAiqtUCgOUhS1tVPIuyMAb0+8pwR/ZktLCzIyMrIIunuCG6Mo6pVCocgC7R68Dt4iU2NxYWH6llYr2A+odENDw4v09PRcf0r7B4WD8+R6x9vt9qmysrLsf1KaSRYcZ34YuWPO80KHsxbMSwioNANdUFBQTpJkI9gCvhF8qnOve/739fXd7enpuQfqAwXNFMFxXEcQRB345vtR1D/jXzZm+cnAQHVXV9cdEDA7DmDitmMIgqjCcdwIneATuGfDuxcGBwfrzGbzbdi60EqzBdVqdXVRUVGl7/jjNtxm2QXy729P9PDw8IPW1tZyWOCAlWYLt5vabcnHk6EO9kJ2Wl5eni8pKTkZCHDQ0AaD4VFu7sVrUgnNd6iD4piefmutqjKooII5QQHbg8mtqakZzczMvMzXDPyw7mTabLbnOp3uUkigm5qaXiOIQun9UcW23mNmXiaHw/FBo9GcDQm0xWJxyWSyaFhF+aBomv6lUqkiQwIt9FkFC8BOGCwv8M+woDztDxo02vg2A/Pa9s0NGBpFUZler//Jjh52Hm8X3iV3uVzfttxbawciI+WxsXHxXidaH0+VlpZGzc/Pu2HvUNAjj88ebrf7R3d3t2FoaKiJhcAw7BxJkqNRUVFxe8CkEknI7GE2mz8mJiaeYiFomv5tsVgaTSaTjk8xkiTv5+fn6yMiImRszMrKyufi4uLUQFQOWmkmUavVNqelpV1YWlp6U19fXwLbuKKiwoQgSPbc3NwERVE3YfO4cQF7OpgmYueEocVWVOiYEKpeovUJ20M0KQGFwkqHSuk/KuY6PY6Xvo0AAAAASUVORK5CYII=')");
      p_.style.color = "gray";
      a1.style.color = '#C665FE';
      a2.style.color = '#C665FE';
      logoBanner.src = require('./logo512.png');
    }else{
      userConfig.nightMode = "vs";
      console.log(userConfig.nightMode)
      realCSSVars.style.setProperty("--backGclr", "#9d2bFb");
      realCSSVars.style.setProperty("--backGclrContextMenu", "#888");
      realCSSVars.style.setProperty("--optClr", "color");
      realCSSVars.style.setProperty("--contextMenu", "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAAXNSR0IArs4c6QAAA9NJREFUaEPtl29IE2EcxzeZpaIrpV6YhtKtzBJfTDAjo3vRG29vxJSLCo/JsTc1/7zYgmkEzUBFkc5/TB1iWkoiydAR+EYLhLQsqSU5NYNBwiQzczoqLk69dpu7e56tYyRsr8Y9vz+f53vf+91zUsk+/En3IbMkDB2quxZWOqy0gAJhe7DiqNVqo1KpxGZmZp51dnZWim0b0ZVua2t7l5qSkkHvkjocjlmNRnNGTHBRobOysmKMRuMGU5SFZmCbm5tzrFbrS7HARYXu7e11JCQkJHHhmAbf19dXcBw/+l9CW61WrsBejBiGiSaQaIU6Ojpmk5KTTnv5goPtdDo/EQRxQgy1RYPmU9njb6kEw/JE6SdKkf7+fqdcLj8CUnHT5Vq7Ulh4GBQHWg8YGkXRDARBrubknC+IiYk+FB8ff0yoie8kYWJXV79+2XBtrk1NTj61222Px8Ym3oNAfR9uYLxer3+IougNiQTmKOsPk9OCf5keHx/vq62tvQ4CAiqtUCgOUhS1tVPIuyMAb0+8pwR/ZktLCzIyMrIIunuCG6Mo6pVCocgC7R68Dt4iU2NxYWH6llYr2A+odENDw4v09PRcf0r7B4WD8+R6x9vt9qmysrLsf1KaSRYcZ34YuWPO80KHsxbMSwioNANdUFBQTpJkI9gCvhF8qnOve/739fXd7enpuQfqAwXNFMFxXEcQRB345vtR1D/jXzZm+cnAQHVXV9cdEDA7DmDitmMIgqjCcdwIneATuGfDuxcGBwfrzGbzbdi60EqzBdVqdXVRUVGl7/jjNtxm2QXy729P9PDw8IPW1tZyWOCAlWYLt5vabcnHk6EO9kJ2Wl5eni8pKTkZCHDQ0AaD4VFu7sVrUgnNd6iD4piefmutqjKooII5QQHbg8mtqakZzczMvMzXDPyw7mTabLbnOp3uUkigm5qaXiOIQun9UcW23mNmXiaHw/FBo9GcDQm0xWJxyWSyaFhF+aBomv6lUqkiQwIt9FkFC8BOGCwv8M+woDztDxo02vg2A/Pa9s0NGBpFUZler//Jjh52Hm8X3iV3uVzfttxbawciI+WxsXHxXidaH0+VlpZGzc/Pu2HvUNAjj88ebrf7R3d3t2FoaKiJhcAw7BxJkqNRUVFxe8CkEknI7GE2mz8mJiaeYiFomv5tsVgaTSaTjk8xkiTv5+fn6yMiImRszMrKyufi4uLUQFQOWmkmUavVNqelpV1YWlp6U19fXwLbuKKiwoQgSPbc3NwERVE3YfO4cQF7OpgmYueEocVWVOiYEKpeovUJ20M0KQGFwkqHSuk/KuY6PY6Xvo0AAAAASUVORK5CYII=')");
      p_.style.color = "white";
      a1.style.color = '#4b274f';
      a2.style.color = '#B24CFF';
      logoBanner.src = require('./logo512white.png');
    }
  }

  function saver(){
    var jsonFile = JSON.stringify(userConfig); 
    var element = document.createElement('a'); 
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(jsonFile));
    element.setAttribute('download', "settings.json");
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  function importer(){
    var input = document.createElement('input');
    input.type = 'file';
    input.onchange = e => {
      // getting a hold of the file reference
      var file = e.target.files[0]; 
      // setting up the reader
      var reader = new FileReader();
      reader.readAsText(file,'UTF-8');
      // here we tell the reader what to do when it's done reading...
      reader.onload = readerEvent => {

        var content = readerEvent.target.result; // this is the content!
        var parsedFile = JSON.parse(content);
        var nightModeCheckbox = document.getElementById('nightModeCheckbox');
        var warningsCheckbox = document.getElementById('warningsCheckbox');

        warningsCheckbox.checked = userConfig.showWarnings;
        nightModeCheckbox.checked = userConfig.nightMode;
        userConfig.showWarnings = parsedFile.showWarnings.toString();
        userConfig.nightMode = parsedFile.nightMode.toString();

        console.log(userConfig.showWarnings);

      }
    }
    input.click();



    checker();

  }

}

export default App;